import React from 'react'
import { Typography, Form } from 'antd'
import { furniture } from '../assets/constants'
import _ from 'lodash'
import ExtraRadioGroup from './extraRadioGroup'

const { Title } = Typography

const Furniture = (props) => {
  return (
    <>
      <Title>Cosa metti a disposizione?</Title>
      <Form.Item name='furniture'>
        <ExtraRadioGroup
          values={furniture}
          defaultValue={_.get(props.formValue, 'furniture')}
          setOnForm={(value) => {
            props.addValue({ furniture: value })
            props.form.setFieldsValue({ furniture: value })
          }}
          name='furniture'
          multiple
        />
      </Form.Item>
    </>
  )
}

export default Furniture
